<script setup lang="ts">
import EmptyStateIconUrl from '@Shared/components/visuals/visualAssets/EmptyState_Icon.svg?url';
defineProps<{
  showHasNoDataMessage?: boolean;
}>();
</script>
<template>
  <div class="flex flex-row items-center justify-center">
    <div class="ml-3 flex flex-row pr-4 w-100% items-center gap-5">
      <div class="inline-block loading-gradient h-[30px] w-[30px] rounded-2"></div>
      <div class="mobile:my-5 flex flex-col w-75% my-7 gap-2">
        <div class="inline-block loading-gradient h-[8px] w-50% rounded-2"></div>
        <div class="inline-block loading-gradient h-[8px] w-60% rounded-2"></div>
        <div class="inline-block loading-gradient h-[8px] w-30% rounded-2"></div>
      </div>
    </div>
    <div
      v-if="showHasNoDataMessage"
      class="mobile:text-4 mobile:heading-6 absolute text-center text-3 text-[#828282] font-family[Roboto] line-height-1rem"
    >
      <img :src="EmptyStateIconUrl" alt="" />
      <div class="max-w-[250px] m-auto mobile:max-w-[300px]">
        <span>
          We are still crunching the numbers.<br />
          Watch this space for insights.
        </span>
      </div>
    </div>
  </div>
</template>
